const exportContractToExcel = async (data, fileName) => {

  const { default: ExcelJS } = await import("exceljs");
  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
  };

  // Preparamos filas (una por cada LER; si no hay LER, una fila vacía)
  const rows = data.flatMap(d => {
    const base = {
      number_nt: d.number_nt || "",
      date_contract: formatDate(d.date_contract),
      amount_contract: d.amount_contract ?? "",
      periodicity_contract: d.periodicity_contract ?? "",
      duration_contract: d.duration_contract ?? "",
      opt_doc: d.opt_tras_documentid ?? "",
      opt_name: d.opt_tras_tradename ?? "",
      opt_nima: d.opt_tras_nima ?? "",
      ori_doc: d.ori_tras_documentid ?? "",
      ori_name: d.ori_tras_tradename ?? "",
      ori_nima: d.ori_tras_nima ?? "",
      ori_dir: d.ori_tras_street ?? "",
      ori_loc: d.ori_tras_locality ?? "",
      ori_cp: d.ori_tras_postalcode ?? "",
      ori_dir_fiscal: d.ori_tras_street_fiscal ?? "",
      ori_loc_fiscal: d.ori_tras_locality_fiscal ?? "",
      ori_cp_fiscal: d.ori_tras_postalcode_fiscal ?? "",
      dest_doc: d.dest_tras_documentid ?? "",
      dest_name: d.dest_tras_tradename ?? "",
      dest_nima: d.dest_tras_nima ?? "",
      dest_inscription: d.dest_tras_inscription ?? ""
    };

    const lines = d.contractCodeLERGroupedDTO?.length
      ? d.contractCodeLERGroupedDTO.map(l => ({
          ...base,
          codeler_code: l.codeler_code ?? "",
          codeler_namees: l.codeler_namees ?? "",
          processtypes: l.processtypes ?? "",
          treatmenttypes: l.treatmenttypes ?? ""
        }))
      : [{ ...base, codeler_code: "", codeler_namees: "", processtypes: "", treatmenttypes: "" }];

    return lines;
  });

  // Workbook/Worksheet
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("CONTRATOS", { properties: { defaultRowHeight: 18 } });

  // Definición de columnas (header, key, width)
  ws.columns = [
    { header: "Nº CONTRATO", key: "number_nt", width: 16 },
    { header: "FECHA CONTRATO", key: "date_contract", width: 16 },
    { header: "CANTIDAD ESTIMADA", key: "amount_contract", width: 18 },
    { header: "PERIOCIDAD ESTIMADA", key: "periodicity_contract", width: 20 },
    { header: "DURACIÓN CONTRATO", key: "duration_contract", width: 20 },
    { header: "OPERADOR Nº DOCUMENTO", key: "opt_doc", width: 22 },
    { header: "OPERADOR RAZÓN SOCIAL", key: "opt_name", width: 28 },
    { header: "OPERADOR NIMA", key: "opt_nima", width: 16 },
    { header: "ORIGEN Nº DOCUMENTO", key: "ori_doc", width: 22 },
    { header: "ORIGEN RAZÓN SOCIAL", key: "ori_name", width: 28 },
    { header: "ORIGEN NIMA", key: "ori_nima", width: 16 },
    { header: "ORIGEN DIRECCIÓN", key: "ori_dir", width: 28 },
    { header: "ORIGEN LOCALIDAD", key: "ori_loc", width: 20 },
    { header: "ORIGEN CÓDIGO POSTAL", key: "ori_cp", width: 18 },
    { header: "ORIGEN DIRECCIÓN FISCAL", key: "ori_dir_fiscal", width: 28 },
    { header: "ORIGEN LOCALIDAD FISCAL", key: "ori_loc_fiscal", width: 22 },
    { header: "ORIGEN CÓDIGO POSTAL FISCAL", key: "ori_cp_fiscal", width: 24 },
    { header: "DESTINO Nº DOCUMENTO", key: "dest_doc", width: 22 },
    { header: "DESTINO RAZÓN SOCIAL", key: "dest_name", width: 28 },
    { header: "DESTINO NIMA", key: "dest_nima", width: 16 },
    { header: "ORIGEN Nº INSCRIPCIÓN", key: "dest_inscription", width: 22 },
    { header: "CÓDIGO LER", key: "codeler_code", width: 14 },
    { header: "DESCRIPCIÓN LER", key: "codeler_namees", width: 30 },
    { header: "PROCESOS", key: "processtypes", width: 24 },
    { header: "TRATAMIENTOS", key: "treatmenttypes", width: 24 }
  ];

  // Añade filas
  ws.addRows(rows);

  // Estilo cabecera
  const headerRow = ws.getRow(1);
  headerRow.height = 22;
  headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
  headerRow.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  headerRow.eachCell((cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "a7b8ee" } }; // azul elegante
    cell.border = {
      top: { style: "thin", color: { argb: "FFFFFFFF" } },
      bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      left: { style: "thin", color: { argb: "FFFFFFFF" } },
      right: { style: "thin", color: { argb: "FFFFFFFF" } }
    };
  });

  // Alinea datos y bordes suaves
  ws.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;
    row.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      cell.border = {
        top: { style: "hair" },
        bottom: { style: "hair" },
        left: { style: "hair" },
        right: { style: "hair" }
      };
    });
  });

  // Congelar cabecera y poner autofiltro
  ws.views = [{ state: "frozen", ySplit: 1 }];
  ws.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: ws.columnCount }
  };

  // Descargar
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default exportContractToExcel;
